// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `section.upload-videos-sec .upload-vid {
    /*width: 360px;*/
    height: auto;
}

.upload-videos-sec .upload-vid>h3 {
    font-size: 24px;
    text-align: center;
    margin-bottom: 22px;
}

.upload-vid .upload-v-btn {
    padding: 15px;
    background-color: #9ca9ba;
    box-shadow: 1px 1px 6px 0px rgba(0, 0, 0, 0.3);
    margin-bottom: 15px;
}

.cancel-upload-button {
    width: 15px;
    position: absolute;
    z-index: 9;
    cursor: pointer;
    right: 0;
    top: 0px;
}

.betaTag {
    color: red;
}

.cancel-upload-button img {
    width: 100%;
}

.upload-vid .upload-v-btn>button {
    border: none;
    background: none;
    width: 100%;
    border-bottom: 1px solid #ffffff61;
    margin-bottom: 10px;
    padding-bottom: 10px;
    outline: none;
}

.upload-vid .upload-v-btn>button:last-child {
    border-bottom: none;
    margin-bottom: 0px;
    padding-bottom: 0px;
}

.upload-vid .upload-v-btn>button .media img {
    width: 26px;
    height: 26px;
}

.upload-vid .upload-v-btn>button .media-body h5 {
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
}

.upload-vid .upload-v-btn > button .media-body p {
    font-size: 12px;
    color: #ffffff;
    margin-bottom: 0px;
}

/*.upload-vid .upload-other-btn {*/
/*    background-color: #ffffff;*/
/*    padding: 25px;*/
/*    margin-bottom: 30px;*/
/*    border-radius: 8px;*/
/*    box-shadow: 1px 1px 6px 0px rgba(0, 0, 0, 0.3)*/
/*}*/

.choose-vid h6 {
    word-break: break-all;
    width: 100px;
}

.upload-vid .upload-other-btn > .txt img {
    width: 25px;
    height: 25px;
    border: 1px solid #000;
    padding: 5px;
    border-radius: 5px;

}

.templatetype {
    float: left;
    width: 50%;
    overflow-wrap: break-word;
    padding: 5px;
}

.templatetype.okay1 .fonrmation img {
    width: 42px;
    height: auto;
    top: 27px;
}

.templatetype.okay2 .fonrmation img {
    width: 29px;
    height: auto;
    left: 10px;
    top: 26px
}

.templatetype.okay3 .fonrmation img {
    width: 42px;
    height: auto;
    left: 10px;
    top: 16px
}

.templatetype.okay4 .fonrmation img {
    width: 40px;
    height: auto;
    left: 10px;
    top: 22px;
}

.templatetype.okay5 .fonrmation img {
    width: 25px;
    height: auto;
    left: 15px;
    top: 27px;
}

.templatetype.okay6 .fonrmation img {
    width: 12px;
    height: auto;
    left: 25px;
    top: 21px;
}

.templatetype.okay7 .fonrmation img {
    width: 45px;
    height: auto;
    left: 10px;
    top: 27px;
}

.templatetype.okay8 .fonrmation img {
    width: 44px;
    height: auto;
    left: 10px;
    top: 17px;
}

.upload-vid.templar {
    width: 600px!important;
    font-size: 14px;
}

.templatetype .fonrmation {
    background: #fff;
    padding: 15px 10px;
    width: 100%;
    position: relative;
    padding-left: 60px;
    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.3);
}

.templatetype .fonrmation span {
    display: block;
}

.templatetype .fonrmation span:first-child {
    font-weight: bold;
}

.templatetype .fonrmation img {
    width: 50px;
    height: 50px;
    object-fit: cover;
    position: absolute;
    left: 10px;
    top: 10px;
}

.left-arrow-on {
    color: #717171;
    position: absolute;
    left: 15px;
    top: 95px;
}

.left-arrow-on img {
    width: 15px;
}

.opeinds {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    text-align: center;
    /*border-radius: 15px;
    box-shadow: 0px 1px 15px rgba(152, 152, 152, 0.15);
    border: 2px solid #ffffff;*/
    padding: 25px;
    margin-bottom: 10px;
    background: white;
    width: 100%;
    height: 100%;
    margin-top: 20px;
    position: relative;
}

.opeinds .info {
    cursor: pointer;
    position: absolute;
    top: 7px;
    right: 7px;
}

.upload-vid .upload-other-btn>.txt h5 {
    font-size: 16px;
    margin-bottom: 0px;
}

.upload-vid .upload-other-btn .other-buttons>div button {
    width: 30px;
    height: auto;
    background: none;
    border: none;
}

.upload-vid .upload-other-btn .other-buttons>div button img {
    width: 100%;
    height: 100%;
}

.upload-vid .upload-v-btn .more-btn button {
    box-shadow: none;
    float: right;
    padding: 0px 10px;
    margin-bottom: 15px;
}

.upload-vid .upload-v-btn .more-btn button::after {
    display: none;
}

.upload-vid .upload-v-btn .more-btn button img {
    width: 20px;
    height: 20px;
}


/* Upload video popup */

.upload-vid-Modal .modal-body,
.upload-url-Modal .modal-body {
    padding: 0px 25px 25px 25px;
}

.upload-vid-Modal .modal-header,
.upload-url-Modal .modal-header {
    padding: 25px;
}

.upload-vid-Modal .modal-header .modal-title,
.upload-url-Modal .modal-header .modal-title {
    font-size: 19px;
}

.upload-vid-Modal .modal-body .select-vid-area .upload-img {
    width: 65px;
    height: 65px;
    background-color: #9ca9ba;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 15px;
}

.upload-vid-Modal .modal-body .select-vid-area button {
    border: 1px solid #6e5eff;
    padding: 8px 30px;
    border-radius: 5px;
    background: #6e5eff;
    color: #ffff;
    font-size: 15px;
    outline: none;
}

.upload-vid-Modal .modal-body .select-vid-area {
    border: 1px dotted black;
    border-radius: 10px;
    padding: 28px 15px;
}

.upload-vid-Modal .modal-body .select-vid-area p {
    font-size: 14px;
}

.upload-vid-Modal {
    padding-right: 15px !important;
    padding-left: 15px !important;
}

.upload-vid-Modal .vid-library-options .vid-options .txt h5 {
    font-size: 17px;
}

.upload-vid-Modal .vid-library-options .vid-options {
    display: flex;
    justify-content: space-between;
}

.upload-vid-Modal .vid-library-options .vid-options .txt p {
    font-size: 14px;
    margin-bottom: 0px;
}

.vid-library-options .vid-options .search button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0px;
}

.vid-library-options .vid-options .search>input {
    /* padding-right: 40px; */
    width: 44px;
}

.vid-library-options .vid-options .search button svg {
    fill: black;
}

.upload-vid-list .choose-vid .form-group label img {
    width: 90px;
    height: 60px;
    object-fit: cover;
}

.upload-vid-list .choose-vid .form-group label h6 samp {
    font-size: 14px;
    color: #a4a4a5;
    margin-top: 2px;
}

.upload-vid-list>.row .vid-timing samp {
    font-size: 14px;
    color: #a4a4a5;
}

.upload-vid-list>.row .vid-timing {
    width: 100%;
}

.upload-vid-Modal .modal-body .upload-vid-list {
    height: 300px;
}

.vid-list-btn {
    width: 100% !important;
    padding-right: 40px;
}

.upload-vid-list .choose-vid .form-group label {
    position: relative;
    cursor: pointer;
}

.upload-vid-list .choose-vid .form-group label:before {
    content: '';
    border: 1px solid black;
    padding: 10px;
    margin-right: 5px;
    border-radius: 50%;
}

.upload-vid-list .choose-vid .form-group input:checked+label:after {
    content: '';
    position: absolute;
    left: 9px;
    width: 6px;
    height: 14px;
    border: solid #0079bf;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
}


/* Upload video popup */


/* Upload url popup */

.upload-url-Modal {
    padding-right: 15px !important;
    padding-left: 15px !important;
}

.size-block {
    margin-top: 10px;
}

.upload-url-Modal .vid-url-body .url-txt {
    margin-top: 10px;
}

.upload-url-Modal .vid-url-body .url-txt h6 {
    color: #a4a4a5;
    margin-bottom: 2px;
}

.upload-url-Modal .vid-url-body .url-txt p {
    color: #a4a4a5;
    font-size: 14px;
}

.upload-url-Modal .vid-url-body button {
    float: right;
    border: 1px solid #6e5eff;
    padding: 8px 30px;
    border-radius: 5px;
    background: #6e5eff;
    color: #ffff;
    margin-top: -58px;
    font-size: 15px;
}


/* Upload url popup */

.upload-videos-sec {
    margin-top: 50px;
    margin-bottom: 50px;
}

.button-style input {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
    cursor: pointer;
}

.button-style {
    border: 1px solid #6e5eff;
    padding: 8px 30px;
    border-radius: 5px;
    background: #6e5eff;
    color: #ffff;
    font-size: 15px;
    display: block;
    width: 200px;
    margin: 0 auto;
    cursor: pointer;
    position: relative;
    outline: none;
}

.cancel-button {
    background: red!important;
    border: 1px solid red!important;
    cursor: pointer;
    margin-left: 15px
}

.custom-btn {
    margin-top: 15px;
}

.fileName {
    font-size: 16px;
    text-align: left;
}

.fileName span {
    float: right;
    margin-right: 30px;
}

.uploaded-percetange {
    margin-bottom: 15px;
    padding: 0px;
}

samp {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}

@media(max-width: 991px) {
    .button-style {
        display: block!important;
        width: 100%!important;
    }
    .form-check {
        display: block!important;
    }
    .video-title {
        width: 100% !important;
        text-align: left !important;
        margin-top: 10px;
        margin-left: 10px;
    }
    .video-stats {
        text-align: left !important;
        padding-left: 10px!important;
        margin-top: 10px;
    }
    .row.vid-timing {
        margin-left: 0px!important;
    }
    .animations {
        padding: 10px 0;
        box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
        margin: 1px;
    }
    .video-js {
        margin-left: 0px!important;
        width: 100%;
        height: 140px;
    }
    .upload-vid.templar {
        width: 100%!important;
    }
}

.help-box {
    width: 40%;
    background: #5721bf!important;
    margin-right: 18px;
    /* height: 64vh; */
    border: 2px solid #da6c31;
    padding: 10px;
    position: relative;
    color: white;
}

.help-box::after {
    content: "";
    position: absolute;
    border-width: 15px;
    border-style: solid;
    border-color: transparent transparent transparent #da6c31;
    height: 24px;
    right: -32px;
    top: 19px;
}

.help-box h6 {
    font-weight: bold;
}

.help-box p {
    margin-bottom: 5px;
    font-size: 14px;
}

.help-box i {
    right: 9px;
    position: absolute;
}

/* WC 07202022 */
.modal-body h2 {
    display: inline-block;
    font-size: 14px;
    font-weight: normal;
    margin-left: 10px;

}
/* WC 07202022*/

@media (max-width: 767px) {
    .help-box {
        position: relative;
        left: -5px;
        top: 0px;
        width: 50%;
        background: #5721bf!important;
        margin-right: 18px;
        /* height: 64vh; */
        border: 2px solid #da6c31;
        padding: 10px;
        color: white;
    }
    
    .help-box::after {
        content: "";
        position: absolute;
        border-width: 15px;
        border-style: solid;
        border-color: transparent transparent transparent #da6c31;
        height: 24px;
        right: -32px;
        top: 250px;
    }
}

@media (max-width: 576px) { 
    .help-box {
        position: relative;
        left: -5px;
        top: 0px;
        width: 50%;
        background: #5721bf!important;
        margin-right: 18px;
        /* height: 64vh; */
        border: 2px solid #da6c31;
        padding: 10px;
        color: white;
    }
    
    .help-box::after {
        content: "";
        position: absolute;
        border-width: 15px;
        border-style: solid;
        border-color: transparent transparent transparent #da6c31;
        height: 24px;
        right: -32px;
        top: 250px;
    }
}


/**/
.help-box1 {
    position: absolute;
    left: 175px;
    background: #5721bf !important;
    border-radius: 5px;
    padding: 17px;
    top: 55px;
    width: 244px;
    border: 2px solid #da6c31;
    color: white;
    font-size: 15px;
    z-index: 2;
}


.help-box1::after {
    content: "";
    position: absolute;
    top: 5%;
    right: 100%;
    margin-top: 0;
    border-width: 15px;
    border-style: solid;
    border-color: transparent #da6c31 transparent transparent;
    height: 24px;
}

.uv-img {
    padding-top: 2rem;
}


.btn-book {
    border: 1px solid #6438b4;
    color: #fff;
    background-color: #6438b4;
    margin-left: 15px;
    margin-top: 15px;
    box-shadow: none;
}

.btn-book:hover {
    color: #6438b4;
    background-color: #fff;
}

.btn-book .hoverarrow {
    display: none;
}

.btn-book:hover .nohover {
    display: none;
}

.btn-book:hover .hoverarrow {
    display: inline-block;
    width: 21px;
}

.card {
    cursor: pointer;
    text-align: start;
    border-radius: 15px;
    height: 100%;
    box-shadow: 0px 1px 15px rgba(152, 152, 152, 0.15);
    border: 2px solid #ffffff;
    padding: 25px;
    margin-bottom: 10px;
    transition: all .2s ease-in-out;
}

.card.disabled {
    cursor: default;
    pointer-events: none;
    background-color: #e9ecef;
    border-color: #e9ecef;
}

.card h6 {
    text-transform: uppercase;
}



.card .s-n p {
    margin: 0;
    font-weight: 400;
    font-size: 18px;
    color: #5c5c5c;
    text-align: center;
}

.card .complete {
    position: absolute;
    right: 15px;
    top: 20px;
}

.card:hover:not(.disabled) {
    transform: scale(1.02);
    -webkit-transform: scale(1.02);
}

.card .s-n {

    padding: 20px;
    text-align: center;
}

.card .s-n .type {
    display: flex;
    margin: 15px 0px;
    justify-content: center;
    align-items: flex-end;

}

.uv-i {
    padding-bottom: 0.5rem;
}

.hero {
    padding: 30px 100px;
    text-align: center;
}

#agreement-Modal .modal-body {
    height: 65vh;
    overflow: auto;
}

ul li {
    list-style-position: inside;
    padding-left: 20px;
}

.sib {
    height: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    margin-top: 2rem;
}

.btn-bg {
    color: #fff;
    background-color: #6438b4;
}


.howto-btn:hover {
    color: #ffffff;
    background-color: #6438b4;
}

.howto-btn {
    font-style: normal;
    font-weight: 500 !important;
    font-size: 14px;
    border: 2px solid #6438B4;
    padding: 10px 24px;
    /*margin-top: 20px;*/
    border-radius: 5px;
    /*font-weight: bold;*/
    background-color: transparent;
    color: #6438B4;
    margin: auto 5px 5px;
}

@media (max-width: 1200px) {
    .hero .col-lg-4 {
        margin: 15px 0 !important;
    }
}

@media (max-width: 1500px) {
    .hero {
        padding: 40px 35px;
    }
}


@media (max-width: 420px) {
    .hero {
        padding: 40px 10px;
    }
}

@media(max-width: 991px) {
    #HowToVideoModal iframe{
        height:260px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/uploadVideos/uploadVideos.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,8CAA8C;IAC9C,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,QAAQ;IACR,QAAQ;AACZ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,kCAAkC;IAClC,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA,kCAAkC;AAClC,iCAAiC;AACjC,qBAAqB;AACrB,2BAA2B;AAC3B,0BAA0B;AAC1B,qDAAqD;AACrD,IAAI;;AAEJ;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;;AAEtB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB;;+BAE2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;;AAGA,uBAAuB;;AAEvB;;IAEI,2BAA2B;AAC/B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,wBAAwB;AAC5B;;;AAGA,uBAAuB;;;AAGvB,qBAAqB;;AAErB;IACI,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;;AAGA,qBAAqB;;AAErB;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,YAAY;IACZ,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;IAC/B,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,6MAA6M;AACjN;;AAEA;IACI;QACI,wBAAwB;QACxB,qBAAqB;IACzB;IACA;QACI,wBAAwB;IAC5B;IACA;QACI,sBAAsB;QACtB,2BAA2B;QAC3B,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,2BAA2B;QAC3B,4BAA4B;QAC5B,gBAAgB;IACpB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,eAAe;QACf,8CAA8C;QAC9C,WAAW;IACf;IACA;QACI,0BAA0B;QAC1B,WAAW;QACX,aAAa;IACjB;IACA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,UAAU;IACV,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,yDAAyD;IACzD,YAAY;IACZ,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA,gBAAgB;AAChB;IACI,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,iBAAiB;;AAErB;AACA,eAAe;;AAEf;IACI;QACI,kBAAkB;QAClB,UAAU;QACV,QAAQ;QACR,UAAU;QACV,6BAA6B;QAC7B,kBAAkB;QAClB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,kBAAkB;QAClB,mBAAmB;QACnB,yDAAyD;QACzD,YAAY;QACZ,YAAY;QACZ,UAAU;IACd;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,UAAU;QACV,QAAQ;QACR,UAAU;QACV,6BAA6B;QAC7B,kBAAkB;QAClB,kBAAkB;QAClB,yBAAyB;QACzB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,kBAAkB;QAClB,mBAAmB;QACnB,yDAAyD;QACzD,YAAY;QACZ,YAAY;QACZ,UAAU;IACd;AACJ;;;AAGA,GAAG;AACH;IACI,kBAAkB;IAClB,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,UAAU;AACd;;;AAGA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,yDAAyD;IACzD,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,yBAAyB;IACzB,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,kDAAkD;IAClD,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;;;AAIA;IACI,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;;IAEI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;;AAEzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;;AAGA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,qBAAqB;IACrB,6BAA6B;IAC7B,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;;AAGA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":["section.upload-videos-sec .upload-vid {\r\n    /*width: 360px;*/\r\n    height: auto;\r\n}\r\n\r\n.upload-videos-sec .upload-vid>h3 {\r\n    font-size: 24px;\r\n    text-align: center;\r\n    margin-bottom: 22px;\r\n}\r\n\r\n.upload-vid .upload-v-btn {\r\n    padding: 15px;\r\n    background-color: #9ca9ba;\r\n    box-shadow: 1px 1px 6px 0px rgba(0, 0, 0, 0.3);\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.cancel-upload-button {\r\n    width: 15px;\r\n    position: absolute;\r\n    z-index: 9;\r\n    cursor: pointer;\r\n    right: 0;\r\n    top: 0px;\r\n}\r\n\r\n.betaTag {\r\n    color: red;\r\n}\r\n\r\n.cancel-upload-button img {\r\n    width: 100%;\r\n}\r\n\r\n.upload-vid .upload-v-btn>button {\r\n    border: none;\r\n    background: none;\r\n    width: 100%;\r\n    border-bottom: 1px solid #ffffff61;\r\n    margin-bottom: 10px;\r\n    padding-bottom: 10px;\r\n    outline: none;\r\n}\r\n\r\n.upload-vid .upload-v-btn>button:last-child {\r\n    border-bottom: none;\r\n    margin-bottom: 0px;\r\n    padding-bottom: 0px;\r\n}\r\n\r\n.upload-vid .upload-v-btn>button .media img {\r\n    width: 26px;\r\n    height: 26px;\r\n}\r\n\r\n.upload-vid .upload-v-btn>button .media-body h5 {\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    color: #ffffff;\r\n}\r\n\r\n.upload-vid .upload-v-btn > button .media-body p {\r\n    font-size: 12px;\r\n    color: #ffffff;\r\n    margin-bottom: 0px;\r\n}\r\n\r\n/*.upload-vid .upload-other-btn {*/\r\n/*    background-color: #ffffff;*/\r\n/*    padding: 25px;*/\r\n/*    margin-bottom: 30px;*/\r\n/*    border-radius: 8px;*/\r\n/*    box-shadow: 1px 1px 6px 0px rgba(0, 0, 0, 0.3)*/\r\n/*}*/\r\n\r\n.choose-vid h6 {\r\n    word-break: break-all;\r\n    width: 100px;\r\n}\r\n\r\n.upload-vid .upload-other-btn > .txt img {\r\n    width: 25px;\r\n    height: 25px;\r\n    border: 1px solid #000;\r\n    padding: 5px;\r\n    border-radius: 5px;\r\n\r\n}\r\n\r\n.templatetype {\r\n    float: left;\r\n    width: 50%;\r\n    overflow-wrap: break-word;\r\n    padding: 5px;\r\n}\r\n\r\n.templatetype.okay1 .fonrmation img {\r\n    width: 42px;\r\n    height: auto;\r\n    top: 27px;\r\n}\r\n\r\n.templatetype.okay2 .fonrmation img {\r\n    width: 29px;\r\n    height: auto;\r\n    left: 10px;\r\n    top: 26px\r\n}\r\n\r\n.templatetype.okay3 .fonrmation img {\r\n    width: 42px;\r\n    height: auto;\r\n    left: 10px;\r\n    top: 16px\r\n}\r\n\r\n.templatetype.okay4 .fonrmation img {\r\n    width: 40px;\r\n    height: auto;\r\n    left: 10px;\r\n    top: 22px;\r\n}\r\n\r\n.templatetype.okay5 .fonrmation img {\r\n    width: 25px;\r\n    height: auto;\r\n    left: 15px;\r\n    top: 27px;\r\n}\r\n\r\n.templatetype.okay6 .fonrmation img {\r\n    width: 12px;\r\n    height: auto;\r\n    left: 25px;\r\n    top: 21px;\r\n}\r\n\r\n.templatetype.okay7 .fonrmation img {\r\n    width: 45px;\r\n    height: auto;\r\n    left: 10px;\r\n    top: 27px;\r\n}\r\n\r\n.templatetype.okay8 .fonrmation img {\r\n    width: 44px;\r\n    height: auto;\r\n    left: 10px;\r\n    top: 17px;\r\n}\r\n\r\n.upload-vid.templar {\r\n    width: 600px!important;\r\n    font-size: 14px;\r\n}\r\n\r\n.templatetype .fonrmation {\r\n    background: #fff;\r\n    padding: 15px 10px;\r\n    width: 100%;\r\n    position: relative;\r\n    padding-left: 60px;\r\n    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.templatetype .fonrmation span {\r\n    display: block;\r\n}\r\n\r\n.templatetype .fonrmation span:first-child {\r\n    font-weight: bold;\r\n}\r\n\r\n.templatetype .fonrmation img {\r\n    width: 50px;\r\n    height: 50px;\r\n    object-fit: cover;\r\n    position: absolute;\r\n    left: 10px;\r\n    top: 10px;\r\n}\r\n\r\n.left-arrow-on {\r\n    color: #717171;\r\n    position: absolute;\r\n    left: 15px;\r\n    top: 95px;\r\n}\r\n\r\n.left-arrow-on img {\r\n    width: 15px;\r\n}\r\n\r\n.opeinds {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    text-align: center;\r\n    /*border-radius: 15px;\r\n    box-shadow: 0px 1px 15px rgba(152, 152, 152, 0.15);\r\n    border: 2px solid #ffffff;*/\r\n    padding: 25px;\r\n    margin-bottom: 10px;\r\n    background: white;\r\n    width: 100%;\r\n    height: 100%;\r\n    margin-top: 20px;\r\n    position: relative;\r\n}\r\n\r\n.opeinds .info {\r\n    cursor: pointer;\r\n    position: absolute;\r\n    top: 7px;\r\n    right: 7px;\r\n}\r\n\r\n.upload-vid .upload-other-btn>.txt h5 {\r\n    font-size: 16px;\r\n    margin-bottom: 0px;\r\n}\r\n\r\n.upload-vid .upload-other-btn .other-buttons>div button {\r\n    width: 30px;\r\n    height: auto;\r\n    background: none;\r\n    border: none;\r\n}\r\n\r\n.upload-vid .upload-other-btn .other-buttons>div button img {\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n\r\n.upload-vid .upload-v-btn .more-btn button {\r\n    box-shadow: none;\r\n    float: right;\r\n    padding: 0px 10px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.upload-vid .upload-v-btn .more-btn button::after {\r\n    display: none;\r\n}\r\n\r\n.upload-vid .upload-v-btn .more-btn button img {\r\n    width: 20px;\r\n    height: 20px;\r\n}\r\n\r\n\r\n/* Upload video popup */\r\n\r\n.upload-vid-Modal .modal-body,\r\n.upload-url-Modal .modal-body {\r\n    padding: 0px 25px 25px 25px;\r\n}\r\n\r\n.upload-vid-Modal .modal-header,\r\n.upload-url-Modal .modal-header {\r\n    padding: 25px;\r\n}\r\n\r\n.upload-vid-Modal .modal-header .modal-title,\r\n.upload-url-Modal .modal-header .modal-title {\r\n    font-size: 19px;\r\n}\r\n\r\n.upload-vid-Modal .modal-body .select-vid-area .upload-img {\r\n    width: 65px;\r\n    height: 65px;\r\n    background-color: #9ca9ba;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    border-radius: 50%;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.upload-vid-Modal .modal-body .select-vid-area button {\r\n    border: 1px solid #6e5eff;\r\n    padding: 8px 30px;\r\n    border-radius: 5px;\r\n    background: #6e5eff;\r\n    color: #ffff;\r\n    font-size: 15px;\r\n    outline: none;\r\n}\r\n\r\n.upload-vid-Modal .modal-body .select-vid-area {\r\n    border: 1px dotted black;\r\n    border-radius: 10px;\r\n    padding: 28px 15px;\r\n}\r\n\r\n.upload-vid-Modal .modal-body .select-vid-area p {\r\n    font-size: 14px;\r\n}\r\n\r\n.upload-vid-Modal {\r\n    padding-right: 15px !important;\r\n    padding-left: 15px !important;\r\n}\r\n\r\n.upload-vid-Modal .vid-library-options .vid-options .txt h5 {\r\n    font-size: 17px;\r\n}\r\n\r\n.upload-vid-Modal .vid-library-options .vid-options {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.upload-vid-Modal .vid-library-options .vid-options .txt p {\r\n    font-size: 14px;\r\n    margin-bottom: 0px;\r\n}\r\n\r\n.vid-library-options .vid-options .search button {\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    right: 0px;\r\n}\r\n\r\n.vid-library-options .vid-options .search>input {\r\n    /* padding-right: 40px; */\r\n    width: 44px;\r\n}\r\n\r\n.vid-library-options .vid-options .search button svg {\r\n    fill: black;\r\n}\r\n\r\n.upload-vid-list .choose-vid .form-group label img {\r\n    width: 90px;\r\n    height: 60px;\r\n    object-fit: cover;\r\n}\r\n\r\n.upload-vid-list .choose-vid .form-group label h6 samp {\r\n    font-size: 14px;\r\n    color: #a4a4a5;\r\n    margin-top: 2px;\r\n}\r\n\r\n.upload-vid-list>.row .vid-timing samp {\r\n    font-size: 14px;\r\n    color: #a4a4a5;\r\n}\r\n\r\n.upload-vid-list>.row .vid-timing {\r\n    width: 100%;\r\n}\r\n\r\n.upload-vid-Modal .modal-body .upload-vid-list {\r\n    height: 300px;\r\n}\r\n\r\n.vid-list-btn {\r\n    width: 100% !important;\r\n    padding-right: 40px;\r\n}\r\n\r\n.upload-vid-list .choose-vid .form-group label {\r\n    position: relative;\r\n    cursor: pointer;\r\n}\r\n\r\n.upload-vid-list .choose-vid .form-group label:before {\r\n    content: '';\r\n    border: 1px solid black;\r\n    padding: 10px;\r\n    margin-right: 5px;\r\n    border-radius: 50%;\r\n}\r\n\r\n.upload-vid-list .choose-vid .form-group input:checked+label:after {\r\n    content: '';\r\n    position: absolute;\r\n    left: 9px;\r\n    width: 6px;\r\n    height: 14px;\r\n    border: solid #0079bf;\r\n    border-width: 0 2px 2px 0;\r\n    transform: rotate(45deg);\r\n}\r\n\r\n\r\n/* Upload video popup */\r\n\r\n\r\n/* Upload url popup */\r\n\r\n.upload-url-Modal {\r\n    padding-right: 15px !important;\r\n    padding-left: 15px !important;\r\n}\r\n\r\n.size-block {\r\n    margin-top: 10px;\r\n}\r\n\r\n.upload-url-Modal .vid-url-body .url-txt {\r\n    margin-top: 10px;\r\n}\r\n\r\n.upload-url-Modal .vid-url-body .url-txt h6 {\r\n    color: #a4a4a5;\r\n    margin-bottom: 2px;\r\n}\r\n\r\n.upload-url-Modal .vid-url-body .url-txt p {\r\n    color: #a4a4a5;\r\n    font-size: 14px;\r\n}\r\n\r\n.upload-url-Modal .vid-url-body button {\r\n    float: right;\r\n    border: 1px solid #6e5eff;\r\n    padding: 8px 30px;\r\n    border-radius: 5px;\r\n    background: #6e5eff;\r\n    color: #ffff;\r\n    margin-top: -58px;\r\n    font-size: 15px;\r\n}\r\n\r\n\r\n/* Upload url popup */\r\n\r\n.upload-videos-sec {\r\n    margin-top: 50px;\r\n    margin-bottom: 50px;\r\n}\r\n\r\n.button-style input {\r\n    opacity: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: 9;\r\n    cursor: pointer;\r\n}\r\n\r\n.button-style {\r\n    border: 1px solid #6e5eff;\r\n    padding: 8px 30px;\r\n    border-radius: 5px;\r\n    background: #6e5eff;\r\n    color: #ffff;\r\n    font-size: 15px;\r\n    display: block;\r\n    width: 200px;\r\n    margin: 0 auto;\r\n    cursor: pointer;\r\n    position: relative;\r\n    outline: none;\r\n}\r\n\r\n.cancel-button {\r\n    background: red!important;\r\n    border: 1px solid red!important;\r\n    cursor: pointer;\r\n    margin-left: 15px\r\n}\r\n\r\n.custom-btn {\r\n    margin-top: 15px;\r\n}\r\n\r\n.fileName {\r\n    font-size: 16px;\r\n    text-align: left;\r\n}\r\n\r\n.fileName span {\r\n    float: right;\r\n    margin-right: 30px;\r\n}\r\n\r\n.uploaded-percetange {\r\n    margin-bottom: 15px;\r\n    padding: 0px;\r\n}\r\n\r\nsamp {\r\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !important;\r\n}\r\n\r\n@media(max-width: 991px) {\r\n    .button-style {\r\n        display: block!important;\r\n        width: 100%!important;\r\n    }\r\n    .form-check {\r\n        display: block!important;\r\n    }\r\n    .video-title {\r\n        width: 100% !important;\r\n        text-align: left !important;\r\n        margin-top: 10px;\r\n        margin-left: 10px;\r\n    }\r\n    .video-stats {\r\n        text-align: left !important;\r\n        padding-left: 10px!important;\r\n        margin-top: 10px;\r\n    }\r\n    .row.vid-timing {\r\n        margin-left: 0px!important;\r\n    }\r\n    .animations {\r\n        padding: 10px 0;\r\n        box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);\r\n        margin: 1px;\r\n    }\r\n    .video-js {\r\n        margin-left: 0px!important;\r\n        width: 100%;\r\n        height: 140px;\r\n    }\r\n    .upload-vid.templar {\r\n        width: 100%!important;\r\n    }\r\n}\r\n\r\n.help-box {\r\n    width: 40%;\r\n    background: #5721bf!important;\r\n    margin-right: 18px;\r\n    /* height: 64vh; */\r\n    border: 2px solid #da6c31;\r\n    padding: 10px;\r\n    position: relative;\r\n    color: white;\r\n}\r\n\r\n.help-box::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    border-width: 15px;\r\n    border-style: solid;\r\n    border-color: transparent transparent transparent #da6c31;\r\n    height: 24px;\r\n    right: -32px;\r\n    top: 19px;\r\n}\r\n\r\n.help-box h6 {\r\n    font-weight: bold;\r\n}\r\n\r\n.help-box p {\r\n    margin-bottom: 5px;\r\n    font-size: 14px;\r\n}\r\n\r\n.help-box i {\r\n    right: 9px;\r\n    position: absolute;\r\n}\r\n\r\n/* WC 07202022 */\r\n.modal-body h2 {\r\n    display: inline-block;\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n    margin-left: 10px;\r\n\r\n}\r\n/* WC 07202022*/\r\n\r\n@media (max-width: 767px) {\r\n    .help-box {\r\n        position: relative;\r\n        left: -5px;\r\n        top: 0px;\r\n        width: 50%;\r\n        background: #5721bf!important;\r\n        margin-right: 18px;\r\n        /* height: 64vh; */\r\n        border: 2px solid #da6c31;\r\n        padding: 10px;\r\n        color: white;\r\n    }\r\n    \r\n    .help-box::after {\r\n        content: \"\";\r\n        position: absolute;\r\n        border-width: 15px;\r\n        border-style: solid;\r\n        border-color: transparent transparent transparent #da6c31;\r\n        height: 24px;\r\n        right: -32px;\r\n        top: 250px;\r\n    }\r\n}\r\n\r\n@media (max-width: 576px) { \r\n    .help-box {\r\n        position: relative;\r\n        left: -5px;\r\n        top: 0px;\r\n        width: 50%;\r\n        background: #5721bf!important;\r\n        margin-right: 18px;\r\n        /* height: 64vh; */\r\n        border: 2px solid #da6c31;\r\n        padding: 10px;\r\n        color: white;\r\n    }\r\n    \r\n    .help-box::after {\r\n        content: \"\";\r\n        position: absolute;\r\n        border-width: 15px;\r\n        border-style: solid;\r\n        border-color: transparent transparent transparent #da6c31;\r\n        height: 24px;\r\n        right: -32px;\r\n        top: 250px;\r\n    }\r\n}\r\n\r\n\r\n/**/\r\n.help-box1 {\r\n    position: absolute;\r\n    left: 175px;\r\n    background: #5721bf !important;\r\n    border-radius: 5px;\r\n    padding: 17px;\r\n    top: 55px;\r\n    width: 244px;\r\n    border: 2px solid #da6c31;\r\n    color: white;\r\n    font-size: 15px;\r\n    z-index: 2;\r\n}\r\n\r\n\r\n.help-box1::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 5%;\r\n    right: 100%;\r\n    margin-top: 0;\r\n    border-width: 15px;\r\n    border-style: solid;\r\n    border-color: transparent #da6c31 transparent transparent;\r\n    height: 24px;\r\n}\r\n\r\n.uv-img {\r\n    padding-top: 2rem;\r\n}\r\n\r\n\r\n.btn-book {\r\n    border: 1px solid #6438b4;\r\n    color: #fff;\r\n    background-color: #6438b4;\r\n    margin-left: 15px;\r\n    margin-top: 15px;\r\n    box-shadow: none;\r\n}\r\n\r\n.btn-book:hover {\r\n    color: #6438b4;\r\n    background-color: #fff;\r\n}\r\n\r\n.btn-book .hoverarrow {\r\n    display: none;\r\n}\r\n\r\n.btn-book:hover .nohover {\r\n    display: none;\r\n}\r\n\r\n.btn-book:hover .hoverarrow {\r\n    display: inline-block;\r\n    width: 21px;\r\n}\r\n\r\n.card {\r\n    cursor: pointer;\r\n    text-align: start;\r\n    border-radius: 15px;\r\n    height: 100%;\r\n    box-shadow: 0px 1px 15px rgba(152, 152, 152, 0.15);\r\n    border: 2px solid #ffffff;\r\n    padding: 25px;\r\n    margin-bottom: 10px;\r\n    transition: all .2s ease-in-out;\r\n}\r\n\r\n.card.disabled {\r\n    cursor: default;\r\n    pointer-events: none;\r\n    background-color: #e9ecef;\r\n    border-color: #e9ecef;\r\n}\r\n\r\n.card h6 {\r\n    text-transform: uppercase;\r\n}\r\n\r\n\r\n\r\n.card .s-n p {\r\n    margin: 0;\r\n    font-weight: 400;\r\n    font-size: 18px;\r\n    color: #5c5c5c;\r\n    text-align: center;\r\n}\r\n\r\n.card .complete {\r\n    position: absolute;\r\n    right: 15px;\r\n    top: 20px;\r\n}\r\n\r\n.card:hover:not(.disabled) {\r\n    transform: scale(1.02);\r\n    -webkit-transform: scale(1.02);\r\n}\r\n\r\n.card .s-n {\r\n\r\n    padding: 20px;\r\n    text-align: center;\r\n}\r\n\r\n.card .s-n .type {\r\n    display: flex;\r\n    margin: 15px 0px;\r\n    justify-content: center;\r\n    align-items: flex-end;\r\n\r\n}\r\n\r\n.uv-i {\r\n    padding-bottom: 0.5rem;\r\n}\r\n\r\n.hero {\r\n    padding: 30px 100px;\r\n    text-align: center;\r\n}\r\n\r\n#agreement-Modal .modal-body {\r\n    height: 65vh;\r\n    overflow: auto;\r\n}\r\n\r\nul li {\r\n    list-style-position: inside;\r\n    padding-left: 20px;\r\n}\r\n\r\n.sib {\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: flex-end;\r\n    justify-content: center;\r\n    margin-top: 2rem;\r\n}\r\n\r\n.btn-bg {\r\n    color: #fff;\r\n    background-color: #6438b4;\r\n}\r\n\r\n\r\n.howto-btn:hover {\r\n    color: #ffffff;\r\n    background-color: #6438b4;\r\n}\r\n\r\n.howto-btn {\r\n    font-style: normal;\r\n    font-weight: 500 !important;\r\n    font-size: 14px;\r\n    border: 2px solid #6438B4;\r\n    padding: 10px 24px;\r\n    /*margin-top: 20px;*/\r\n    border-radius: 5px;\r\n    /*font-weight: bold;*/\r\n    background-color: transparent;\r\n    color: #6438B4;\r\n    margin: auto 5px 5px;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n    .hero .col-lg-4 {\r\n        margin: 15px 0 !important;\r\n    }\r\n}\r\n\r\n@media (max-width: 1500px) {\r\n    .hero {\r\n        padding: 40px 35px;\r\n    }\r\n}\r\n\r\n\r\n@media (max-width: 420px) {\r\n    .hero {\r\n        padding: 40px 10px;\r\n    }\r\n}\r\n\r\n@media(max-width: 991px) {\r\n    #HowToVideoModal iframe{\r\n        height:260px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
